import { Link } from "react-router-dom";
import Monogram from "./Monogram";
import { Mail, Crown, Users } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-bdu-gold/10 mt-32">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 pt-20 pb-10 grid md:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <Monogram size={40} />
            <div className="font-serif text-2xl text-bdu-cream">Black Dollars United</div>
          </div>
          <p className="mt-4 text-sm text-bdu-cream/60 max-w-sm">
            A Pan-African economic movement. We are pooling a trillion dollars of collective spending power
            into one fund to rebuild, own, and control the future of our communities.
          </p>
          <div className="mt-6 w-20 h-20 bg-bdu-cream rounded-full p-2 ring-1 ring-bdu-gold/30" data-testid="footer-brand-mark">
            <img
              src="https://customer-assets-lqy194kg.emergentagent.net/job_black-business-pool/artifacts/9vsdscm3_BDU_Logo-01.webp"
              alt="Black Dollars United"
              className="w-full h-full object-contain"
            />
          </div>
        </div>

        <div>
          <div className="label-eyebrow">The Mission</div>
          <ul className="mt-4 space-y-2 text-sm text-bdu-cream/70">
            <li>Manufacturing</li>
            <li>Grocery &amp; Food Franchises</li>
            <li>Hospitals &amp; Health</li>
            <li>Community Banks</li>
            <li>Jobs &amp; Job Training</li>
          </ul>
        </div>

        <div>
          <div className="label-eyebrow">Depository Bank</div>
          <p className="mt-4 text-sm text-bdu-cream/70">
            All fund contributions are held at Citizen Trust Bank —
            a Black-owned depository institution serving our community since 1921.
          </p>
        </div>

        {/* Leadership / Contact */}
        <div data-testid="footer-leadership">
          <div className="label-eyebrow flex items-center gap-2">
            <Crown size={12} className="text-bdu-gold" /> Leadership
          </div>

          <div className="mt-5">
            <div className="font-serif text-xl text-bdu-cream leading-tight">
              Greg L. Bradford
            </div>
            <div className="mt-1 text-[11px] uppercase tracking-[0.25em] text-bdu-gold/90">
              Founder · CEO · President
            </div>
          </div>

          <div className="mt-5 pt-5 border-t border-bdu-gold/10">
            <div className="text-[10px] uppercase tracking-[0.25em] text-bdu-cream/40 mb-2">Direct Contact</div>
            <a
              href="mailto:greg@blackdollarsunited.org"
              className="group inline-flex items-center gap-2 text-sm text-bdu-cream/85 hover:text-bdu-gold transition-colors"
              data-testid="footer-contact-email"
            >
              <Mail size={14} className="text-bdu-gold" />
              <span className="border-b border-bdu-gold/30 group-hover:border-bdu-gold pb-0.5">
                greg@blackdollarsunited.org
              </span>
            </a>
          </div>

          <Link
            to="/board"
            className="mt-5 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-bdu-gold hover:text-bdu-cream transition-colors"
            data-testid="footer-board-link"
          >
            <Users size={12} /> Board &amp; Committee →
          </Link>
        </div>
      </div>

      {/* Signature tagline — gold hairline + serif italic */}
      <div className="max-w-7xl mx-auto px-6 sm:px-10">
        <div className="relative py-10 border-t border-bdu-gold/15 text-center" data-testid="footer-signature-tagline">
          <div
            className="absolute left-1/2 -top-px -translate-x-1/2 h-px w-40"
            style={{ background: "linear-gradient(90deg, transparent, rgba(212,175,55,0.7), transparent)" }}
          />
          <div className="font-serif text-3xl sm:text-4xl tracking-tight text-bdu-cream">
            The <span className="italic text-bdu-gold">Power</span> of the Black Dollar
          </div>
          <div className="mt-3 text-[10px] uppercase tracking-[0.4em] text-bdu-cream/40">
            One Community · One Fund · One Future
          </div>
        </div>
      </div>

      <div className="border-t border-bdu-gold/10 py-6 text-center text-xs text-bdu-cream/40 tracking-widest uppercase">
        © {new Date().getFullYear()} Black Dollars United — Trillion Dollar Spending Power Fund
      </div>
    </footer>
  );
}
